export default __webpack_public_path__ + "static/media/history-white.b724d5a0.svg";